// Libs
import classNames from 'classnames/bind';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
import { ActivityDetailTable } from '~/components/module/activity';
// Others
import { IActivity } from '~/utils/interface/activity';
import { formatDate, getFullName } from '~/utils/helper/common';
import { ActivityTypeEnum, DateFormatEnum } from '~/utils/enum/common';
// Styles, images, icons
import styles from './ActivityDetailModal.module.scss';

type Props = {
  isOpen: boolean;
  activity?: IActivity;
  onClose: () => void;
};

const cx = classNames.bind(styles);

const ActivityDetailModal = (props: Props) => {
  //#region Destructuring Props
  const { isOpen, activity, onClose } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/activity', 'common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [scroll] = useState<DialogProps['scroll']>('paper');
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const renderTitle = () => {
    switch (activity?.actionType) {
      case ActivityTypeEnum.CREATE_INVENTORY:
        return t('activity_title_create_inventory');

      case ActivityTypeEnum.UPDATE_INVENTORY:
        return t('activity_title_update_inventory');

      case ActivityTypeEnum.DELETE_INVENTORY:
        return t('activity_title_delete_inventory');

      default:
        break;
    }
  };

  const handleCloseActivityDetailModal = () => {
    onClose && onClose();
  };
  //#endregion Handle Function

  return (
    <Dialog
      id='activityDetailModalComponent'
      open={isOpen}
      onClose={handleCloseActivityDetailModal}
      fullWidth
      maxWidth={'md'}
    >
      <Stack className={cx('viewHeader')}>
        <DialogTitle className={cx('titleHeader')}>{t('activity_detail_title')}</DialogTitle>
      </Stack>

      <DialogContent dividers={scroll === 'paper'} className={cx('body')}>
        <Stack gap={3}>
          <Typography component={'p'} className={cx('activityValue')}>
            {renderTitle()}
          </Typography>

          {activity?.createdBy && (
            <Typography component={'p'} className={cx('activityValue')}>
              {t('activity_detail_update_by', { name: getFullName({ ...activity?.createdBy }) })}
            </Typography>
          )}

          <Typography component={'p'} className={cx('activityValue')}>
            {t('activity_detail_update_at', {
              date: `${formatDate(activity?.createdAt)} ${formatDate(activity?.createdAt, DateFormatEnum.HH_mm_A)}`,
            })}
          </Typography>

          {activity && <ActivityDetailTable data={activity} />}
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button variant='contained' onClick={handleCloseActivityDetailModal} className={cx('buttonClose')}>
          {t('common_action_close', { ns: 'common/base' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ActivityDetailModal;
